import { Modal } from 'bootstrap5';

const forms = {
	contact: '#form-contact',
	business: '#form-business',
}
const modals = {
	contact: document.querySelector('#modal-form-contact'),
	business: document.querySelector('#modal-form-business'),
}

$(forms.contact).on('submit-success', function(event, data) {
	const modal = new Modal((modals.contact), {
		keyboard: false,
		focus: true,
	})
	modal.show()
})

$(forms.business).on('submit-success', function(event, data) {
	const modal = new Modal((modals.business), {
		keyboard: false,
		focus: true,
	})
	modal.show()
})

$('#accordion-faq-user').on('shown.bs.collapse', function (e) {
	var $panel = $(e.target);

	var $header = $panel.closest('.accordion-item').find('.accordion-header');

	var headerTop = $header.offset().top;
	var windowTop = $(window).scrollTop();

	var offsetPadding = 120;

	if (headerTop - 100 < windowTop) {
		$('html, body').animate({
			scrollTop: headerTop - offsetPadding
		}, 1);
	}
});